import { viewJobNativeModule } from './ViewJobNativeModule';
import { callPromiseAssert } from '../../shared/util/callPromiseAssert';

export function onDeepLinkLoadCompleted() {
    return callPromiseAssert(
        viewJobNativeModule()?.onDeepLinkLoadCompleted,
        'onDeepLinkLoadCompleted',
    );
}
